var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2049 4.72501H4.79493C2.15082 4.72501 0 6.87604 0 9.51994V32.4799C0 35.1238 2.15103 37.2748 4.79493 37.2748H37.2049C39.8488 37.2748 42 35.1238 42 32.4799V9.51994C42 6.87604 39.8488 4.72501 37.2049 4.72501ZM21 34.755H4.79493C3.5406 34.755 2.52 33.7346 2.52 32.4801V9.51994C2.52 8.2654 3.5406 7.24501 4.79493 7.24501H21V34.755ZM38.3418 15.9871C38.2269 17.9076 37.1515 21.7119 33.9593 24.3545C34.9285 24.5692 35.9814 24.6849 37.0925 24.6849V27.2049C34.8768 27.2049 32.8425 26.8019 31.114 26.0866C29.4993 26.7798 27.5505 27.2049 25.2078 27.2049V24.6849C26.2855 24.6849 27.2918 24.5797 28.2246 24.3703C26.4581 22.8969 25.4144 20.945 25.4144 18.7465H27.9342C27.9342 20.6065 29.1228 22.2151 31.0598 23.2873C32.0344 22.7287 32.8873 22.0038 33.6143 21.1136C34.7962 19.6676 35.3997 18.0642 35.6626 16.9048H25.2078V14.3848H29.8901V11.8677H32.4101V14.385H36.8317C37.2487 14.385 37.6511 14.5595 37.9359 14.8638C38.2171 15.1618 38.3664 15.5726 38.3418 15.9871Z",
    fill: "#EB2F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03718 24.835L8.10269 27.1992H4.74878L10.2833 14.3703H13.6372L19.0439 27.1992H15.5615L14.6452 24.835H9.03718ZM11.8596 17.614L9.99017 22.3608H13.6923L11.8596 17.614Z",
    fill: "#EB2F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.c697176b.svg";
export { ForwardRef as ReactComponent };